import React from 'react';

import { ThemeProvider as EduzzThemeProvider } from '@eduzz/ui-antd-theme';

import { type PossibleTheme, useTheme } from '@/hooks/useTheme';

type ThemeProviderProps = {
  children: React.ReactNode;
};

const ThemeContext = React.createContext({ theme: 'light' as PossibleTheme, setTheme: (_theme: PossibleTheme) => {} });

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useTheme();

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <EduzzThemeProvider enableAnimation>{children}</EduzzThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;

export { ThemeContext };
